document.addEventListener('DOMContentLoaded', () => {

if (window.location.pathname.includes('/contact')) {
  const iframe = document.querySelector('.pxFormGenerator iframe');

  if (!iframe) {
    console.warn('[Override] iframe not found');
    return;
  }

  function getHeightForScreenWidth(width) {
    if (width > 1257) return '508px';
    if (width > 602) return '558px';
    return '848px';
  }

  let currentHeight = getHeightForScreenWidth(window.innerWidth);
  iframe.style.height = currentHeight;

  function updateHeight() {
    const newHeight = getHeightForScreenWidth(window.innerWidth);
    if (newHeight !== currentHeight) {
      currentHeight = newHeight;
      iframe.style.height = currentHeight;
    }
  }

  let isSetting = false;

  const observerHeight = new MutationObserver(() => {
    if (isSetting) return; 
    if (iframe.style.height !== currentHeight) {
      isSetting = true;
      iframe.style.height = currentHeight;
      requestAnimationFrame(() => {
        isSetting = false;
      });
    }
  });

  observerHeight.observe(iframe, {
    attributes: true,
    attributeFilter: ['style'],
  });

  
  window.addEventListener('resize', updateHeight);

}
    
  });

window.addEventListener('message', (event) => {

  function formatItems(selector, type = '') {
  const items = document.querySelectorAll(selector);
  const formatted = [];

  items.forEach((item) => {
    const titleEl = item.querySelector('h2');
    const qtyInput = item.querySelector('.quantity__input');
    if (!titleEl || !qtyInput) return;

    const commentElement = item.querySelector('.item-comments');
    formatted.push({
      type,
      title: titleEl.textContent.trim(),
      quantity: qtyInput.value,
      comments: commentElement ? commentElement.value.trim() : ''
    });
  });

  return formatted;
}

  function collectCartDataAndSendToIframe() {
  const maxAttempts = 20;
  let attempts = 0;

  const interval = setInterval(() => {
    const iframe = document.querySelector('.pxFormGenerator iframe');

    if (iframe && iframe.contentWindow) {
      clearInterval(interval); 

      const buyItems = formatItems('.buy-items-container .buy-item', 'buy');
      const rentItems = formatItems('.rent-items-container .rent-item', 'rent');

      //console.log('[Parent] buyItems:', buyItems);
      //console.log('[Parent] rentItems:', rentItems);

      const payload = {
        type: 'updateTextareaOnPageLoad',
        data: {
          buyItems,
          rentItems
        }
      };

      iframe.contentWindow.postMessage(payload, '*');
      //console.log('[Parent] Message sent to iframe.');
    }

    attempts++;
    if (attempts >= maxAttempts) {
      clearInterval(interval);
      //console.warn('[Parent] Iframe not found after waiting.');
    }
  }, 300);
}


const textareas = document.querySelectorAll('.items-quote-hidden');

textareas.forEach((textarea, index) => {
  let lastValue = textarea.value;

  setInterval(() => {
    const currentValue = textarea.value;
    if (currentValue !== lastValue) {
      lastValue = currentValue;
      //console.log(`Detected change in textarea ${index + 1}:`, currentValue);

      const iframes = document.querySelectorAll('.pxFormGenerator iframe');
      iframes.forEach((iframe, iframeIndex) => {
        if (iframe && iframe.contentWindow) {
          iframe.contentWindow.postMessage({
            type: 'updateIframeTextarea',
            payload: currentValue
          }, '*');
          //console.log(`Message sent to iframe ${iframeIndex + 1} with updated textarea value`);
        }
      });
    }
  }, 300);
});
 if (window.location.pathname === '/cart') {
    collectCartDataAndSendToIframe();
   
  }


});


const hubspotFieldMaps = {
  contact: {
   'First name': 'firstname',
  'Last name': 'lastname',
  'Email': 'email',
  'Phone': 'phone',
  'Company': 'company',
  'Business Zip code': 'business_zip_code',
  'Jobsite Zip code': 'jobsite_zip',
    /*'Form Type Traffic': 'traffic_source',*/
    'utm_source': 'utm_source',
    'utm_medium': 'utm_medium',
    'utm_campaign': 'utm_campaign',
    'utm_term': 'utm_term',
    'utm_content': 'utm_content',
    'conversion_page_url': 'conversion_page_url'
  },
  catalog: {
   'Full name': 'firstname',
    'Email': 'email',
    'Form Type Traffic': 'traffic_source'
  
  },
  quote: {
      'First name': 'firstname',
    'Last name': 'lastname',
    'Email': 'email',
    'Phone': 'phone',
    'Company': 'company',
    'Business Zip code': 'business_zip_code',
    'Jobsite Zip code': 'jobsite_zip',
    'Cart Items': 'description',
    'I will require financing for this purchase': 'financing_required',
     /*'Form Type Traffic': 'traffic_source',*/
     'utm_source': 'utm_source',
    'utm_medium': 'utm_medium',
    'utm_campaign': 'utm_campaign',
    'utm_term': 'utm_term',
    'utm_content': 'utm_content',
    'conversion_page_url': 'conversion_page_url'
  }
};


function sendToHubspotFromPayload(payload, hubspotFieldMap) {
  const { data, portalId, formId } = payload;

  if (!portalId || !formId) {
    console.error('[HubSpot] Missing Portal ID or Form ID.');
    return;
  }

  const postData = [];

  for (let key in data) {
    const value = data[key];
    if (
      !value?.trim?.() ||
      ['Hubspot Portal ID', 'Hubspot Form ID', 'Redirects To', 'honeypot', 'captcha-answer', 'utf8', 'form_type', 'redirects_to'].includes(key)
    ) continue;

    const hubspotKey = hubspotFieldMap[key];
    if (hubspotKey) {
      postData.push(`${encodeURIComponent(hubspotKey)}=${encodeURIComponent(value)}`);
    }
  }

  const hutk = document.cookie.replace(
    /(?:(?:^|.*;\s*)hubspotutk\s*\=\s*([^;]*).*$)|^.*$/,
    "$1"
  );

  const context = {
    hutk,
    pageUrl: window.location.href,
    pageName: document.title
  };

  postData.push(`hs_context=${encodeURIComponent(JSON.stringify(context))}`);
  const encodedPayload = postData.join('&');

  const xhr = new XMLHttpRequest();
  xhr.open('POST', `https://forms.hubspot.com/uploads/form/v2/${portalId}/${formId}`, true);
  xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

  xhr.onload = function () {
    if (xhr.status >= 200 && xhr.status < 300) {
      console.log('[HubSpot] Form submission successful.');
    } else {
      console.error('[HubSpot] Submission failed:', xhr.responseText);
    }
  };

  xhr.onerror = function () {
    console.error('[HubSpot] Network error.');
  };

  xhr.send(encodedPayload);
}


window.addEventListener('message', function(event) {
   if (!event.data || event.data.type !== 'formSubmitSuccess') return;
  const { data } = event.data;

  let fieldMap = hubspotFieldMaps.contact;
  if ('Full name' in data) {
    fieldMap = hubspotFieldMaps.catalog;
  } else if ('Cart Items' in data) {
    fieldMap = hubspotFieldMaps.quote;
  }

  const portalId = data['Hubspot Portal ID'];
  const formId = data['Hubspot Form ID'];

  sendToHubspotFromPayload({ data, portalId, formId }, fieldMap);

setTimeout(() => {
  const currentUrl = window.location.href;

  if (currentUrl.includes('catalog')) {
    window.location.href = '/pages/catalog-pdf';
  } else {
    window.location.href = '/pages/thank-you';
  }
}, 300);

});
/*window.addEventListener('message', function(event) {



  if (event.data?.type === 'iframeReady') {


    try {
      const visitorSource = JSON.parse(localStorage.getItem('visitorSource'));
      const visitorType = visitorSource?.type || 'unknown';

      const iframe = document.querySelector('.pxFormGenerator iframe');
      if (iframe?.contentWindow) {
        iframe.contentWindow.postMessage(
          {
            type: 'setVisitorSource',
            payload: visitorType,
          },
          '*'
        );

      } else {
        console.warn('[Parent] Iframe contentWindow not available');
      }
    } catch (error) {
      console.error('[Parent] Failed to send visitorSource:', error);
    }
  }

});*/
window.addEventListener('message', function (event) {
  if (event.data?.type !== 'iframeReady') return;

  try {
    const params = new URLSearchParams(window.location.search);

    const iframe = document.querySelector('.pxFormGenerator iframe');
    if (!iframe?.contentWindow) {
      console.warn('[Parent] Iframe contentWindow not available');
      return;
    }

    iframe.contentWindow.postMessage(
      {
        type: 'setVisitorSource',
        payload: {
      
          utm_source: params.get('utm_source') || '',
          utm_medium: params.get('utm_medium') || '',
          utm_campaign: params.get('utm_campaign') || '',
          utm_term: params.get('utm_term') || '',
          utm_content: params.get('utm_content') || '',

         
          current_gclid: params.get('gclid') || '',

        
          conversion_page_url: window.location.href
        }
      },
      '*'
    );

  } catch (error) {
    console.error('[Parent] Failed to send visitor data:', error);
  }
});

